export const BandList = [1, 2, 3, 4, 5];
export const pageLimit = 10;
export const GradeList = [
  "M1",
  "M2",
  "M3",
  "M4",
  "M5",
  "M6",
  "M7",
  "M8",
  "M9",
  "M10",
  "M11",
];
export const reservedSubdomains = [
  "www",
  "admin",
  "api",
  "support",
  "mail",
  "blog",
];
export const nameRegex = /^[A-Za-z]+$/;
export const mobileNumberRegex = /^\d+$/; // regex to allow only numbers
export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const uuidRegex =
  /^[0-9a-f]{8} [0-9a-f]{4} [1-5][0-9a-f]{3} [89ab][0-9a-f]{3} [0-9a-f]{12}$/i;
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
export const subdomainRegex = /^[a-z0-9][a-z0-9-]{1,61}[a-z0-9]$/; // Between 3-63 characters

// ── Reminder interval options shown in the dropdown ──────────
export const REMINDER_INTERVAL_OPTIONS = [
  "3h", "6h", "9h", "12h", "24h", "2d", "3d", "4d", "5d",
];
export const INTERVIEW_REMINDER_CRON_ID = 6;


export const ATTRIBUTE_KEY = {
  AI_JD_GENERATOR:"ai_jd_generator"
}
export const CANDIDATE_STATUS = {
  ONHOLD: "On Hold"
}

export const CANDIDATE_STATUS_LABEL = {
  ON_HOLD_SUFFIX: " – On Hold",
};
